import { render, staticRenderFns } from "./homeFooter.vue?vue&type=template&id=6ec9961e&scoped=true"
import script from "./homeFooter.vue?vue&type=script&lang=js"
export * from "./homeFooter.vue?vue&type=script&lang=js"
import style0 from "./homeFooter.vue?vue&type=style&index=0&id=6ec9961e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec9961e",
  null
  
)

export default component.exports